import React, {Component} from 'react';
import _ from 'lodash';
import {createSelector} from 'reselect';
import {connect} from 'react-redux';
import queryString from 'query-string';
import {bindDispatch} from 'app/utils/redux';
import I18n from 'app/common/i18n';
import * as uiHelper from 'app/utils/uiHelper';

import {MaterialLoader, CandidateReportsView} from 'dk-ui-lib';

class ReportDetailsContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      criteriaScore: 0
    }
  }

  componentDidMount() {
    let {match: {params: {studentId = '', query = ''} = {} }, candidates: {filter: {skills = []}}, actions} = this.props;

    let parsed = queryString.parse(window.location.search);
    let carats = parsed && parsed.carats;

    if(studentId && query) {
      actions.fetchReport(studentId, query);
      actions.fetchCandidateProfile(studentId);
      this.setState({criteriaScore: carats});
    }
  }

	renderLoading() {
    return (
      <div style={uiHelper.PAGE_LOADER_STYLE}><MaterialLoader/></div>
    )
  }

  renderReportsNotFound() {
  	return (
  		<div>{I18n.t('reports.report_not_available')}</div>
  	);
  }

	render() {
		let {reports, candidates, actions} = this.props;

		if (!reports.dataReceived) {
      return this.renderLoading()
    }

    if (_.isEmpty(reports.report)) {
      return this.renderReportsNotFound()
    }
		return (
			<div className='mx4 my1'>
				<CandidateReportsView
          isDetailedReportsView={true} 
          reports={reports}
          candidateProfile={candidates.candidateProfile} 
          criteriaScore={this.state.criteriaScore}/>
			</div>
		);
	}
}

const selector = createSelector(
  state => state.reports,
  state => state.candidates,
  (reports, candidates) => ({ reports, candidates })
);

export default connect(selector, bindDispatch)(ReportDetailsContainer);



// WEBPACK FOOTER //
// ./src/containers/reports/ReportDetailsContainer.js